import { observable, runInAction } from 'mobx';

import API from 'utils/api';
import Logger from 'utils/logger';

import { DEFAULT_FILE_UPLOAD_MAX_SIZE } from 'core/constants';

export const uploadLimits = observable({ fileUploadMaxSize: DEFAULT_FILE_UPLOAD_MAX_SIZE });

export const loadUploadLimits = async (): Promise<void> => {
  try {
    const response = await API.common.getUploadLimits()();
    runInAction(() => {
      uploadLimits.fileUploadMaxSize = response.data.fileUploadMaxSize;
    });
  } catch (e) {
    Logger.error('Invalid upload limits API response', e);
  }
};

export const formatUploadLimit = (): string => `${Math.round(uploadLimits.fileUploadMaxSize / 1024 / 1024)} MB`;

export const isOverUploadLimit = (file: File): boolean => file.size > uploadLimits.fileUploadMaxSize;

export const fileTooLargeMessage = (file: File): string =>
  `"${file.name}" is too large. The limit is ${formatUploadLimit()}.`;
